import * as Sentry from '@sentry/react';
import { Environment } from '../../environment/environments';
import { isLocalhost } from '../environment/utils';

export const sentryReplay = Sentry.replayIntegration({
  networkDetailAllowUrls: [new RegExp('.*')],
  networkCaptureBodies: true,
  networkRequestHeaders: [],
  networkResponseHeaders: ['X-Trace-Url'],
  unmask: ['*'],
  unblock: ['*'],
});

export const initSentry = (environment: Environment) => {
  if (!isLocalhost) {
    // IMPORTANT: this config will make it so that sensitive data / PII might be stored.
    // Only use this config for usage with Panalyt staff
    // If enabling it for all users/clients, the config must be changed (conditionally) to mask sensitive data.
    Sentry.init({
      dsn: 'https://be25460730964e43930b2228a9037ef2@o433529.ingest.sentry.io/5388844',
      environment: environment.name,
      integrations: [Sentry.browserTracingIntegration(), sentryReplay],
      ignoreErrors: ['ChunkLoadError'],
      tracesSampleRate: 1.0,
      // We want to only use sentry replays when manually triggered, so all is set to 0
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,
      tracePropagationTargets: environment.hosts,
    });
  }
};
